import React from 'react'
import { useIntl } from 'react-intl'

import s from './styles.module.scss'

import { getSeasonLabel } from './getSeasonLabel'
import { SeasonEnum } from '../../../../../../../../../lib/graphql'

const SeasonTag = ({ season }: { season: SeasonEnum }) => {
  const intl = useIntl()
  const seasonColors = {
    [SeasonEnum.HIGH]: '#ff0000',
    [SeasonEnum.MEDIUM]: '#f1960d',
    [SeasonEnum.LOW]: '#0cbc8b',
  }

  return (
    <div className={s.season} style={{ backgroundColor: seasonColors[season] }}>
      {intl.formatMessage(getSeasonLabel(season))}
    </div>
  )
}

export default SeasonTag
